import { injectChild } from "@components/constructor";
import { usePagination } from "@hooks/components/constructor.hooks";
import {FC, PropsWithChildren, useMemo} from "react";
import { PaginationProps } from "@constructor/components/core/pagination";
import {useFilteredInventory} from "@hooks/selectors/user/item.selectors";

interface InventoryProps {
    inventory_item_per_page?: number;
    inventory_filter_items_by_login?: boolean;
    inventory_filter_items_by_game?: boolean;
}

interface InventoryChildProps {
    inventory_item_count: number;
}

const Inventory: FC<PropsWithChildren<InventoryProps>> = ({
                                                              inventory_filter_items_by_login,
                                                              inventory_filter_items_by_game,
                                                              inventory_item_per_page = 10,
                                                              children }) => {

    const inventory = useFilteredInventory(inventory_filter_items_by_login, inventory_filter_items_by_game);
    const pagination = usePagination(inventory_item_per_page, inventory.length);

    const data = useMemo<InventoryChildProps & PaginationProps>(() => ({
        inventory_item_count: inventory.length,
        ...pagination
    }), [inventory.length, pagination]);

    return injectChild(data, children);
}

export default Inventory;